import React from 'react';

export default class BatchTimeConfig extends React.Component {
    constructor() {
        super();

        this.state = {
        }

    }

    getValue() {
        let ifr = document.getElementById("ifr");
        let w = ifr.contentWindow;
        if (!w) {
            return;
        }

        let v = w.getValue();
        return v
        // if (!window.frames[0]){
        //     return;
        // }
        // let value = window.frames[0].getValue();
        // tool.sgiLogger.info(value);
        // return value;
    }

    setValue(value) {
        let ifr = document.getElementById("ifr");
        let w = ifr.contentWindow;
        if (!w) {
            return;
        }
        setTimeout(() => {
            w.setValue(value);
        }, 0)


        // if (!window.frames[0]) {
        //     return;
        // }
        // window.frames[0].setValue(value);
    }

    render() {

        window.iframeObjFct = this.props.objFct;

        return (
            <iframe id={"ifr"} src={'/bacthTimeConf/batchTimeConfig.html'} width="100%" height="98%"></iframe>
        )
    }

    // componentDidMount(){
    //     this.setValue("0 0 0 * 1 ? *");
    // }



}



// WEBPACK FOOTER //
// ./apps/pages/thirdPartyComponents/BatchTimeConfig.js